<template>
  <div :style="styles">
    <div 
      class="grid-x align-middle"
      style="line-height:1">
      <div class="cell shrink">
        <span 
          style="padding-right:1rem">
            <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" viewBox="0 0 128 35" style="width:65px" xml:space="preserve">
            <g><circle fill="#000000" cx="17.5" cy="17.5" r="17.5"/><animate attributeName="opacity" dur="2700ms" begin="0s" repeatCount="indefinite" keyTimes="0;0.167;0.5;0.668;1" values="0.3;1;1;0.3;0.3"/></g>
            <g><circle fill="#000000" cx="110.5" cy="17.5" r="17.5"/><animate attributeName="opacity" dur="2700ms" begin="0s" repeatCount="indefinite" keyTimes="0;0.334;0.5;0.835;1" values="0.3;0.3;1;1;0.3"/></g>
            <g><circle fill="#000000" cx="64" cy="17.5" r="17.5"/><animate attributeName="opacity" dur="2700ms" begin="0s" repeatCount="indefinite" keyTimes="0;0.167;0.334;0.668;0.835;1" values="0.3;0.3;1;1;0.3;0.3"/></g>
            </svg>
        </span>
      </div>
      <div v-if="label" class="cell auto">
        <h6 style="font-weight:normal" class="no-margin">{{ label }}</h6>
      </div>
    </div>
  </div>
</template>

<script>
export default { 
  name: 'Loading',
  props: {
    label: {
      type: String
    },
    center: {
      type: Boolean
    }
  },
  computed: {
    styles () {
      let styles = {}
      if (this.center) {
        styles.display = 'inline-block'
        styles.margin = '2rem auto 0'
      }
      return styles
    }
  }
}
</script>
